// W3C Trace Context (https://www.w3.org/TR/trace-context/).
//
// We mint a `traceparent` on every outbound request so a browser action can be
// followed all the way through tio-api and the downstream services. tio-api reads
// this header (see SetRequestContext), continues the trace, and stamps the
// trace_id into its logs — the join key across RUM, logs, and errors in OpenSearch.
//
// tio-data deliberately doesn't depend on tio-common, so this lives here next to
// the request pipeline that uses it.

const randomHex = (bytes: number) => {
  const buffer = new Uint8Array(bytes);
  crypto.getRandomValues(buffer);
  let hex = '';
  for (const byte of buffer) {
    hex += byte.toString(16).padStart(2, '0');
  }
  return hex;
};

// W3C forbids an all-zero trace-id or span-id. The odds are astronomically small
// (2^-128 / 2^-64), but guard so we never emit an invalid traceparent.
const nonZeroHex = (bytes: number) => {
  let hex = randomHex(bytes);
  while (/^0+$/.test(hex)) {
    hex = randomHex(bytes);
  }
  return hex;
};

/**
 * Generate a fresh sampled `traceparent` value:
 *   `00-<32 hex trace-id>-<16 hex span-id>-01`
 *
 * A new trace is minted per request (matching the existing per-request
 * `X-Request-Id` granularity). Grouping a whole user action under one trace —
 * by deriving it from the telemetry session — is a follow-up.
 */
export const generateTraceparent = () => `00-${nonZeroHex(16)}-${nonZeroHex(8)}-01`;
